import { useParams } from "react-router-dom";

import { LoadingPage } from "@/components/elements/Loading/Loading";
import { ProductDetailPage } from "@/features/organization/product/pages/ProductDetail";
import { useProductDetail } from "@/api/services/main/organization/product";

export const ProductDetail = () => {
  const { productId } = useParams<{ productId: string }>();
  const id = Number(productId);
  const { product, isLoading } = useProductDetail(Number.isNaN(id) ? undefined : id);

  if (isLoading) return <LoadingPage />;
  if (!product) return null;

  return <ProductDetailPage product={product} />;
};
